import { useState, useEffect } from 'react'

import * as S from './styles'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// import { useGetCarouselQuery } from '../../services/api'
import { Spinner } from '../LoadingSpinner/styles'

const Carousel = () => {
  // const { data: imagens } = useGetCarouselQuery()

  // if (!imagens) {
  //   return (
  //     <>
  //       <S.LoadingContainer>
  //         <S.Loading>
  //           <Spinner />
  //         </S.Loading>
  //       </S.LoadingContainer>
  //     </>
  //   )
  // }

  return (
    <>
      <div id="carouselExampleCaptions" className="carousel slide">
        <div className="carousel-inner">
          <S.CarouselImageContainer className="carousel-item active">
            <S.CarouselImage src="https://static-file-vault.vercel.app/cdtchechela/banner_chechela_1.png" />
          </S.CarouselImageContainer>
          <S.CarouselImageContainer className="carousel-item">
            <S.CarouselImage src="https://static-file-vault.vercel.app/cdtchechela/banner_chechela_2.png" />
          </S.CarouselImageContainer>
          {/* {imagens.map((imagem, index) => {
            return (
              <>
                <S.CarouselImageContainer
                  key={imagem.id}
                  className={`carousel-item ${index === 0 ? 'active' : ''}`}
                >
                  <S.CarouselImage
                    src={imagem.image}
                    className="d-block w-100"
                    alt={`Imagem: ${imagem.id}`}
                  />
                </S.CarouselImageContainer>
              </>
            )
          })} */}
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </>
  )
}

export default Carousel
